import { useEffect, useState } from "react";
import styles from "./questionBlockSurvey.module.css";
import ImgBuilder from "../../assets/ImgBuilder";
import { SurveyCommon, SurveyLikert} from '../surveyTypes';
import { useTranslation } from "react-i18next";
import { useLanguage } from '../../functions/setGetLanguage';
import { renderWithLineBreaksAndItalic } from '../../functions/renderWithLineBreaksAndItalic';

const QuestionBlockSurvey = ({ style, value, index, selected, onChange}) => {
  const { t } = useTranslation();
  const { language } = useLanguage();

  const [buttonChoices, setButtonChoices] = useState([]);
  useEffect(() => {
    // Base choices in the default shape
    const baseChoices = Array.isArray(value.options)
      ? value.options
      : value.options[language.substring(1)];

    // Append the “prefer not to answer” localized string
    const updatedChoices = baseChoices.concat(t("survey.prefer_not_to"));
    
    setButtonChoices(updatedChoices);
  }, [value.options, language, t]);
  
  
  const isSelected = (option) => {
    return value.question_type === "multiple_choice"
      ? selected.includes(option)
      : selected === option;
  };

  const likertImages = {"likert_time": {
    0: ImgBuilder.never,
    1: ImgBuilder.almostNever,
    2: ImgBuilder.sometimes,
    3: ImgBuilder.almostAlways,
    4: ImgBuilder.always,
  }, "likert_common": {
    0: ImgBuilder.s_disagree,
    1: ImgBuilder.disagree,
    2: ImgBuilder.neutral,
    3: ImgBuilder.agree,
    4: ImgBuilder.s_agree
  }};

  const renderChoices = (option, index_option) => {
    const commonProps = {
      onChange,
      option,
      valStyle: value.question_style,
      isSelected: isSelected(index_option),
      index_option: index_option,
    };

    if (value.question_style === "square_checkmark" || value.question_style === "circle_checkmark") {
      return <SurveyCommon key={index_option} {...commonProps} />;
    }

    if (value.question_style === "likert_common" || value.question_style === "likert_time") {
      return (
        <SurveyLikert
          {...commonProps}
          key={index_option}
          img={likertImages[value.question_style][index_option]}
        />
      );
    }

    return null; 
  };

  return (
    <div style={style} className={styles.registerBlock}>
      <div className={styles.upperPartBlock}>
        <div className={styles.leftUpperPartConBlock}> 
          <div className={styles.circleBlock}>{(index+1)}</div>
        </div>
        <p className={styles.nameBlock}>
          {renderWithLineBreaksAndItalic(typeof value.text === 'object' ? value.text[language.substring(1)] : value.text)}
        </p>
      </div>
      <div className={styles.lowerPartBlock}>
        <div className={styles.leftLowerPartConBlock}></div>
        <div className={styles.inputConBlock}>

          {buttonChoices.map((option, index_option) => 
            renderChoices(option, index_option)
          )}

        </div>
      </div>
    </div>   
  );
};

export default QuestionBlockSurvey;
